export const Bindings = {
	JSONProvider: Symbol("JSONProvider"),
	AuthApiProvider: Symbol("AuthApiProvider"),
	CommonApiProvider: Symbol("CommonApiProvider"),
	ApiHTTPClient: Symbol("ApiHTTPClient"),
	UserApiProvider: Symbol("UserApiProvider"),
	LeaguesApiProvider: Symbol("LeaguesApiProvider"),
	PasswordApiProvider: Symbol("PasswordApiProvider"),
	PredictionApiProvider: Symbol("PredictionApiProvider"),
	JsonHTTPClient: Symbol("JsonHTTPClient"),
	ContentJsonHTTPClient: Symbol("ContentJsonHTTPClient"),
	CountriesStore: Symbol("CountriesStore"),
	RoundsStore: Symbol("RoundsStore"),
	PlayersStore: Symbol("PlayersStore"),
	SquadsStore: Symbol("SquadsStore"),
	UserStore: Symbol("UserStore"),
	LocalizationStore: Symbol("LocalizationStore"),
	StaticContentStore: Symbol("StaticContentStore"),
	AuthController: Symbol("AuthController"),
	LoginController: Symbol("LoginController"),
	RegistrationController: Symbol("RegistrationController"),
	UpdateAccountController: Symbol("UpdateAccountController"),
	CommunicationAccountController: Symbol("CommunicationAccountController"),
	NflAccountController: Symbol("NflAccountController"),
	AccountController: Symbol("AccountController"),
	HelpController: Symbol("HelpController"),
	HelpListController: Symbol("HelpListController"),
	ContactUsController: Symbol("ContactUsController"),
	ChecksumStore: Symbol("ChecksumStore"),
	LiveScoreController: Symbol("LiveScoreController"),
	ForgotPasswordController: Symbol("ForgotPasswordController"),
	ResetPasswordController: Symbol("ResetPasswordController"),
	SessionController: Symbol("SessionController"),
	BootstrapController: Symbol("BootstrapController"),
	LeaguesStore: Symbol("LeaguesStore"),
	TutorialStore: Symbol("TutorialStore"),
	WelcomeModalStore: Symbol("WelcomeModalStore"),
	MyLeaguesController: Symbol("MyLeaguesController"),
	JoinLeaguesController: Symbol("JoinLeaguesController"),
	CreateLeagueController: Symbol("CreateLeagueController"),
	LeagueController: Symbol("LeagueController"),
	LeagueInviteController: Symbol("LeagueInviteController"),
	LeagueSettingsController: Symbol("LeagueSettingsController"),
	LeagueAboutController: Symbol("LeagueAboutController"),
	LeagueInviteFormController: Symbol("LeagueInviteFormController"),
	ModalsStore: Symbol("ModalsStore"),
	ModalErrorController: Symbol("ModalErrorController"),
	ModalConfirmController: Symbol("ModalConfirmController"),
	LocalizationController: Symbol("LocalizationController"),
	HeaderController: Symbol("HeaderController"),
	FooterController: Symbol("FooterController"),
	MenuStore: Symbol("MenuStore"),
	GigyaGateStore: Symbol("GigyaGateStore"),
	GigyaGateController: Symbol("GigyaGateController"),
	DashboardController: Symbol("DashboardController"),
	LandingController: Symbol("LandingController"),
	ConferencesStore: Symbol("ConferencesStore"),
	DivisionsStore: Symbol("DivisionsStore"),
	StandingsStore: Symbol("StandingsStore"),
	TournamentsStore: Symbol("TournamentsStore"),
	LightPredictionsStore: Symbol("LightPredictionsStore"),
	LightPredictorController: Symbol("LightPredictorComponentController"),
	LightPredictionSlotController: Symbol("LightPredictionSlotController"),
	LPDivisionSelectorController: Symbol("LPDivisionSelectorController"),
	LPWildCardController: Symbol("LPWildCardController"),
	SaveBarController: Symbol("SaveBarController"),
	ModalSavePicksController: Symbol("ModalSavePicksController"),
	ModalLosePicksController: Symbol("ModalLosePicksController"),
	LeavePicksPageModal: Symbol("LeavePicksPageModal"),
	LPSavedCardController: Symbol("LPSavedCardController"),
	ModalSharePicksController: Symbol("ModalSharePicksController"),
	LightPredictorPageController: Symbol("LightPredictorPageController"),
	HeavyPredictorPageController: Symbol("HeavyPredictorPageController"),
	LightPredictorSliderController: Symbol("LightPredictorSliderController"),
	LPSliderCardController: Symbol("LPSliderCardController"),
	LPSliderCardOrderController: Symbol("LPSliderCardOrderController"),
	ModalWelcomeLightPredictorController: Symbol("ModalWelcomeLightPredictorController"),
	TutorialController: Symbol("TutorialController"),
	TutorialStepController: Symbol("TutorialStepController"),
	TutorialPaginationController: Symbol("TutorialPaginationController"),
	ShareStore: Symbol("ShareStore"),
	ShareController: Symbol("ShareController"),
	LightPredictorPredictionsController: Symbol("LightPredictorPredictionsController"),
	HeavyPredictionsStore: Symbol("HeavyPredictionsStore"),
	RoundNavigationController: Symbol("RoundNavigationController"),
	RoundNavItemController: Symbol("RoundNavItemController"),
	WeeklyMatchesController: Symbol("WeeklyMatchesController"),
	MatchController: Symbol("MatchController"),
	StandingTableRowController: Symbol("StandingTableRowController"),
	MatchFilterStore: Symbol("MatchFilterStore"),
	MatchFilterController: Symbol("MatchFilterController"),
	ControllBarController: Symbol("ControllBarController"),
	HPPlayoffStandingsController: Symbol("HPPlayoffStandingsController"),
	CompareTableRowController: Symbol("CompareTableRowController"),
	ModalPlayoffFinalController: Symbol("ModalPlayoffFinalController"),
	SecondStepSsoRouteController: Symbol("SecondStepSsoRouteController"),
	LanguageSelectController: Symbol("LanguageSelectController"),
	GeoBlockingController: Symbol("GeoBlockingController"),
	OrderedStandingsStore: Symbol("OrderedStandingsStore"),
	RankingApiProvider: Symbol("RankingApiProvider"),
	OffSeasonController: Symbol("OffSeasonController"),
	RankingStore: Symbol("RankingStore"),
	UserScoringController: Symbol("UserScoringController"),
	ScoringKeysController: Symbol("ScoringKeysController"),
	ModalOffSeasonController: Symbol("ModalOffSeasonController"),
	EndSeasonController: Symbol("EndSeasonController"),
};
